/**
 * ONE CALL'S ID, AS THE TELEPHONY PROVIDER MINTS IT: `CA` and thirty-two lowercase hex digits.
 *
 * The per-call page (ops #13, `docs/seams/phone.md` section 7) is keyed by it, and the phone
 * system's router answers anything else with a bare `404` before it checks a signature, which would
 * tell nobody whether ops signs correctly. So ops holds a sid to this pattern before any door
 * answers or any read is made, and draws "Open the call" only beside a sid that passes it: the
 * server and the screens read the one pattern from here.
 */
const CALL_SID = /^CA[0-9a-f]{32}$/;

export function isCallSid(value: string | null | undefined): value is string {
  return typeof value === 'string' && CALL_SID.test(value);
}
